import React, { useEffect, useRef } from "react";

// Lightweight canvas particle field — slow drifting embers / "ether"
const ParticleField = ({ density = 50, color = "rgba(221,167,79,0.7)" }) => {
  const ref = useRef(null);
  const raf = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = canvas.offsetWidth * window.devicePixelRatio);
    let h = (canvas.height = canvas.offsetHeight * window.devicePixelRatio);
    const dpr = window.devicePixelRatio;

    const onResize = () => {
      w = canvas.width = canvas.offsetWidth * dpr;
      h = canvas.height = canvas.offsetHeight * dpr;
    };
    window.addEventListener("resize", onResize);

    const particles = Array.from({ length: density }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: (Math.random() * 1.4 + 0.3) * dpr,
      vx: (Math.random() - 0.5) * 0.08 * dpr,
      vy: (-Math.random() * 0.18 - 0.05) * dpr,
      a: Math.random() * 0.6 + 0.2,
      twinkle: Math.random() * Math.PI * 2,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.twinkle += 0.02;
        if (p.y < -10) {
          p.y = h + 10;
          p.x = Math.random() * w;
        }
        if (p.x < -10 || p.x > w + 10) p.x = Math.random() * w;
        const alpha = p.a * (0.55 + 0.45 * Math.sin(p.twinkle));
        ctx.beginPath();
        ctx.fillStyle = color.replace(/[\d.]+\)/, `${alpha.toFixed(2)})`);
        ctx.shadowColor = color;
        ctx.shadowBlur = 8 * dpr;
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      });
      raf.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("resize", onResize);
    };
  }, [density, color]);

  return (
    <canvas
      ref={ref}
      className="particle-canvas absolute inset-0 w-full h-full pointer-events-none"
      aria-hidden="true"
    />
  );
};

export default ParticleField;
